"use strict";

/**
 * @ngdoc function
 * @name diceApp.factory:CondensedReport
 * @description
 * # CondensedReport
 * Report resource of the diceApp
 */
angular.module("diceApp").factory("CondensedReport", function (DiceResource, slimNumberFilter) {
  const resource = DiceResource("/condensed-reports", {
    generate: {
      url: "/condensed-reports",
      method: "POST",
      isArray: false
    }
  });

  function formatQuestionAnswers(question) {
    let text;
    if (question.totalAnswerValue > 0) {
      text = `${slimNumberFilter(question.averageValue, 1)} / ${slimNumberFilter(question.medianValue, 1)} / ${slimNumberFilter(question.standardDeviationValue, 1)} (${question.respondentCount})`;
    }
    return text;
  }

  return _.extend(resource, { formatQuestionAnswers });
});
